import { useCallback, useMemo } from 'react';
import './styles/hamburgerButton.scss';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/useStore';
import { setGameWindowContext } from '@/store/actions.ts';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { SHOWOFF_ELEMENTS } from '@/features/Showoff';
import {
  TRACK_USER_ACTION_EVENT,
  useTrackUserAction,
} from '@/utilities/logger/amplitude/tracking';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';

const MenuButton = () => {
  const orientation = useAppOrientation();
  const { gameWindowOpen: isMenuOpen, spinInProgress: isSpinInProgress } =
    useStore(
      useShallow((s) => ({
        gameWindowOpen: s.gameWindowContext.gameWindowOpen,
        spinInProgress: s.gameWindowContext.spinInProgress,
      })),
    );
  const gameLoaded = useStore((s) => s.gameStatus.gameLoadSuccess);
  const { trackUserAction } = useTrackUserAction();
  const { emitClientEvent } = useEventManagerEmitter();

  const canOpen = useMemo(
    () => !isSpinInProgress && gameLoaded,
    [gameLoaded, isSpinInProgress],
  );

  const handleOpenMenu = useCallback(() => {
    if (canOpen) {
      emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.AUTO_SPIN_STOP);
      setGameWindowContext({ gameWindowOpen: true });
      trackUserAction({
        event: TRACK_USER_ACTION_EVENT.IN_GAME_MENU_OPENED,
        zone: 'DASHBOARD',
      });
    }
  }, [canOpen, trackUserAction, emitClientEvent]);

  return (
    <div className={`menu-button ${canOpen ? 'pointer' : ''}`}>
      {isMenuOpen ? null : (
        <div
          className={`open-icon ${orientation} ${!canOpen ? 'spin' : ''}`}
          data-showoff={SHOWOFF_ELEMENTS.MENU_BUTTON}
          data-showoff-notification="false"
          data-testid={canOpen ? 'menu-enabled-button' : 'menu-disabled-button'}
          onClick={handleOpenMenu}
        />
      )}
    </div>
  );
};

export default MenuButton;
